module.exports = __webpack_public_path__ + "img/infopop.766c915b.svg";